import React, { useState, useEffect } from "react";
import PageHeading from "../../../components/PageHeading";
import { BackButton } from "../../../components/btn/Buttons";

import SmallModal from "../../../components/modal/SmallModal";
import {
  Pagination2,
  Pagination3,
} from "../../../components/pagination/pagination";
import { getFinancialYearOptions } from "../../../utils/utils";
import { useSelector } from "react-redux";
import { get_depreciation_report_list } from "../finacialReportSlice";
import store from "../../../redux/store";
import PageLoading from "../../../components/PageLoading";
import Button from "../../../components/btn/Button";
import Dropdown from "../../../components/inputs/Dropdown";

const DepreciationReport = () => {
  const [alerts, setAlerts] = useState(false);
  const [alertsMess, setAlertsMess] = useState("");
  const [financialYear, setFinancialYear] = useState("");

  const { profile_data } = useSelector((state) => state.profile);

  const { depreciation_report_list, depreciation_report_loading } = useSelector(
    (state) => state.finacialReport
  );

  // Fetch data when page, entries, or financial year changes
  useEffect(() => {
    if (financialYear) {
      store.dispatch(
        get_depreciation_report_list({
          fy: financialYear,
        })
      );
    }
  }, [financialYear]);

  const handleYearChange = (event) => {
    setFinancialYear(event.target.value);
  };

  const handleSearch = () => {
    if (!financialYear) {
      setAlerts(true);
      setAlertsMess("Please select a financial year");
      return;
    }

    store.dispatch(
      get_depreciation_report_list({
        fy: financialYear,
      })
    );
  };

  return (
    <div className="container">
      <PageHeading
        title={"Depreciation Report"}
        right={
          <>
            <BackButton />
          </>
        }
      />
      <div className="transactionMain">
        <div style={{ width: "180px" }}>
          <Dropdown
            label={"FINANCIAL YEAR"}
            value={financialYear}
            onChange={handleYearChange}
            options={
              <>
                <option value="">SELECT</option>
                {getFinancialYearOptions(profile_data?.CREATED_DATE)?.map(
                  (v, index) => (
                    <option key={index} value={v}>
                      {v}
                    </option>
                  )
                )}
              </>
            }
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Button title={"SEARCH"} onClick={handleSearch} />
        </div>
      </div>

      <div style={{ height: "10px" }}></div>

      {depreciation_report_loading && depreciation_report_list?.length === 0 ? (
        <PageLoading />
      ) : (
        <>
          {depreciation_report_list?.length > 0 ? (
            <div style={{ overflowX: "auto" }} className="tableScroll">
              <table
                className="table-container"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th
                      rowSpan="2"
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      Asset Name
                    </th>
                    <th
                      rowSpan="2"
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      Description
                    </th>
                    <th
                      rowSpan="2"
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      Type
                    </th>
                    <th
                      rowSpan="2"
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      Opening Value
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                      }}
                    >
                      Q1
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                      }}
                    >
                      Q2
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                      }}
                    >
                      Q3
                    </th>
                    <th
                      colSpan="2"
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                      }}
                    >
                      Q4
                    </th>
                    <th
                      rowSpan="2"
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      Dep Value
                    </th>
                    <th
                      rowSpan="2"
                      style={{ border: "1px solid #ddd", padding: "8px" }}
                    >
                      Closing Value
                    </th>
                  </tr>
                  <tr>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Add
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Deletion
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Add
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Deletion
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Add
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Deletion
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Add
                    </th>
                    <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                      Deletion
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {depreciation_report_list.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {item.ASSET_NAME || "-"}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {item.ASSET_DESC || "-"}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {item.ASSET_TYPE || "-"}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.OPENING_BALANCE || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q1_ADD || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q1_DELETE || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q2_ADD || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q2_DELETE || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q3_ADD || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q3_DELETE || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q4_ADD || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.Q4_DELETE || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.DP_VALUE || 0).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "right",
                            }}
                          >
                            {parseFloat(item?.CLOSING_BALANCE || 0).toFixed(2)}
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            !depreciation_report_loading && (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                {financialYear
                  ? "No assets found for the selected financial year"
                  : "Please select a financial year and click search"}
              </div>
            )
          )}
        </>
      )}

      {alerts && (
        <SmallModal
          isOpen={alerts}
          setIsOpen={setAlerts}
          title={"Alert"}
          mess={alertsMess}
          okbtn={() => setAlerts(false)}
        />
      )}
    </div>
  );
};

export default DepreciationReport;
// import React, { useState } from "react";
// import PageHeading from "../../../components/PageHeading";
// import { BackButton } from "../../../components/btn/Buttons";
// import Dropdown from "../../../components/inputs/Dropdown";
// import Table from "../../../components/table/Table";

// const DepreciationReport = () => {
//   const [open, setOpen] = useState(false);
//   const [flag, setFlag] = useState(false);
//   const [financialYear, setFinancialYear] = useState("");

//   // Handle changing of the financial year
//   const handleYearChange = (event) => {
//     setFinancialYear(event.target.value);
//     // Optionally, fetch data related to the selected year
//     fetchDataForYear(event.target.value);
//   };
//   const fetchDataForYear = (year) => {
//   };
//   return (
//     <div className="container">
//       <PageHeading
//         title={"AGENCY DEPRECIATION REPORT"}
//         right={<BackButton />}
//       />
//       <div style={{ height: "10px" }}></div>
//       <div className="df mt10 gap10">
//         <div style={{ width: "180px" }}>
//           <Dropdown
//             label={"FINANCIAL YEAR"}
//             value={financialYear}
//             onChange={handleYearChange}
//             options={
//               <>
//                 <option value="">SELECT</option>
//                 <option value="2019-20">2019-20</option>
//                 <option value="2020-21">2020-21</option>
//                 <option value="2021-22">2021-22</option>
//                 <option value="2022-23">2022-23</option>
//                 <option value="2023-24">2023-24</option>
//                 <option value="2024-25">2024-25</option>
//               </>
//             }
//           />
//         </div>

//         <div style={{ display: "flex", alignItems: "flex-end" }}>
//           <button className="GENERATE-BTN" onClick={() => setOpen(true)}>FETCH</button>
//         </div>
//       </div>
//       <div style={{ height: "10px" }}></div>
//       {open &&
//         <Table
//           mt={5}
//           headData={[
//             "FINANCIAL YEAR",
//             "CREATED ON",
//             "LAST UPDATED ON",
//             "OPENING BALANCE",
//             "NET ASSET VALUE",
//             "DEPRECIATION AMOUNT",
//             "CLOSING BALANCE",
//             "STATUS",
//             "ACTIONS",
//           ]}
//           body={
//             <>
//               <tr>
//                 <td>{financialYear}</td>
//                 <td>01/01/2023</td>
//                 <td>03/31/2024</td>
//                 <td>$10,000</td>
//                 <td>$9,500</td>
//                 <td>$500</td>
//                 <td>$9,000</td>
//                 <td>Active</td>
//                 <td>
//                   <button className="GENERATE-BTN" onClick={() => setFlag(true)}>PROCESS</button>
//                 </td>
//               </tr>
//             </>
//           }
//         />}
//      {flag&& <div>
//         <Table
//           mt={5}
//           headData={[
//             "DATE",
//             "ITEM",
//             "DR",
//             "CR",
//             "BALANCE",
//           ]}
//           body={
//             <>
//               <tr>
//                 <td>{financialYear}</td>
//                 <td>ITEM</td>
//                 <td>DR</td>
//                 <td>CR</td>
//                 <td>BALANCE</td>
//               </tr>
//             </>
//           }
//         />
//       </div>}
//     </div>
//   );
// };

// export default DepreciationReport;
